const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Whether the value can be an instrument id (entities are named by uuids). */
export function isInstrumentId(value: unknown): value is string {
  return typeof value === "string" && UUID_RE.test(value);
}

function normalizePart(value: string): string {
  return value.trim().replaceAll(/\s+/g, " ").toLowerCase();
}

/**
 * The key two instruments must not share: manufacturer and model, compared
 * without case and with runs of whitespace collapsed.
 */
export function buildInstrumentKey(
  manufacturer: string,
  model: string,
): string {
  return `${normalizePart(manufacturer)}|${normalizePart(model)}`;
}
